import React, { useState, useContext } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, TextField, Button, Grid } from '@mui/material';
import { TokenContext } from '../context/TokenContext';
import { afasPoster } from '../hooks/useAfasDataMutation';

const NewDeviceModal = ({ open, onClose, onSubmit, debtorId, articleId }) => {
  const token = useContext(TokenContext);
  const [formValues, setFormValues] = useState({
    naam: '',
    beschrijving: '',
    identificatie: '',
    serienummer: '',
    laatsteKalibratie: '',
    kalibratieInterval: '',
    kalibratieDatum: '',
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });
  };

  //   const handleSave = async () => {
  //     if (validate()) {
  //       setIsSubmitting(true);
  //       console.log("before save");
  //       const body = {
  //         debtorSelected,
  //         forecastSelected,
  //         subject,
  //         formData: forecastFormData,
  //         aantalDeelnemers,
  //         selectedEvent,
  //       };
  //       const path = `/forecast/createorupdate?forecastId=${forecastSelected?.volgnummer}`;
  //       const arg = { token, body };
  //       const forecastres = await afasPoster(path, { arg });
  //       console.log(forecastres);
  //       setEditMode(false);
  //       setIsSubmitting(false);
  //       setIsSubmitted(true);
  //       subjectRefetch({ throwOnError: true, cancelRefetch: true });

  //       // Hide success message after 3 seconds
  //       setTimeout(() => {
  //         setIsSubmitted(false);
  //       }, 3000);
  //     }
  //   };

  const handleSubmit = async () => {
    setLoading(true);

    try {
      console.log({ formValues });
      console.log(debtorId);
      console.log(articleId);
      // Simulate API call delay

      //   setIsSubmitting(true);
      console.log('before save');
      const body = {
        formValues,
        debtorId,
        articleId,
      };
      const path = `/device`;
      const arg = { token, body };
      const deviceRes = await afasPoster(path, { arg });
      console.log({ deviceRes });
      setLoading(false);
      //   setIsSubmitting(false);
      //   setIsSubmitted(true);
      //   subjectRefetch({ throwOnError: true, cancelRefetch: true });

      // Hide success message after 3 seconds
      //   setTimeout(() => {
      //     setIsSubmitted(false);
      //   }, 3000);

      // await new Promise((res) => setTimeout(res, 1000));

      // Call parent handler
      onSubmit(formValues);
      onClose();
    } catch (err) {
      console.error('Submission error', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Nieuw apparaat toevoegen</DialogTitle>
      <DialogContent dividers>
        <Grid container spacing={2} sx={{ mt: 1 }}>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Naam apparaat"
              name="naam"
              value={formValues.naam}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Beschrijving apparaat"
              name="beschrijving"
              value={formValues.beschrijving}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              fullWidth
              label="Identificatienummer"
              name="identificatie"
              value={formValues.identificatie}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              fullWidth
              label="Serienummer"
              name="serienummer"
              value={formValues.serienummer}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              fullWidth
              label="Laatste kalibratie"
              name="laatsteKalibratie"
              type="date"
              InputLabelProps={{ shrink: true }}
              value={formValues.laatsteKalibratie}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              fullWidth
              label="Kalibratie-interval"
              name="kalibratieInterval"
              value={formValues.kalibratieInterval}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Kalibratiedatum"
              name="kalibratieDatum"
              type="date"
              InputLabelProps={{ shrink: true }}
              value={formValues.kalibratieDatum}
              onChange={handleChange}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Annuleren</Button>
        <Button onClick={handleSubmit} variant="contained" disabled={loading}>
          {loading ? 'Toevoegen...' : 'Toevoegen'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default NewDeviceModal;
